import styled from 'styled-components';

export const Container = styled.section`
  padding: 4.5rem;
  display: flex;
  justify-content: start;
  align-items: flex-start;
  font-family: 'Noto Sans KR', serif;
  background: #ffffff;
`;

interface IButtonWrapperProps {
  errorCode: number;
}

export const ButtonWrapper = styled.div<IButtonWrapperProps>`
  width: ${(props) => (props.errorCode === 404 ? '96px' : '134px')};

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 8px 14px;
    letter-spacing: -0.03em;
    text-align: center;
    line-height: 140%;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 56px;
`;

export const ErrorMessageWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  white-space: nowrap;
`;

export const Status = styled.span`
  font-size: 5rem;
  font-weight: 800;
  line-height: 125%;
  letter-spacing: -0.06em;
  color: #e5e5e5;
`;

export const Message = styled.span`
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.03em;
  color: #595959;
`;

export const ContentWrap = styled.div`
  width: 334px;

  p {
    white-space: pre-wrap;
    font-size: 1rem;
    font-weight: 400;
    line-height: 160%;
    letter-spacing: -0.03em;
    color: #999999;
  }
`;
